module.exports = __webpack_public_path__ + "static/car-de5f6fd6323575eecc08fb5d4c18ca53.jpg";